import { message } from "antd";
import { Decimal } from 'decimal.js';

export function sleep(t:number) {
  return new Promise((res,rej)=>{
    const timer = setTimeout(() => {
      clearTimeout(timer)
      res(t)
    }, t);
  })
}

export const formatTenThousand = (num:any) => {
  if(num !==0 && !num) return 0
  if(num.toString().includes('-1')) return '无'
  if(num>10000) {
    return (num/10000).toFixed(2) + '万'
  }else {
    return num
  }
}

export const excel = (blob:Blob,name:string) =>{
  if(blob instanceof Blob) {
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `${name||'数据导出'}.xlsx`

    // 触发下载
    downloadLink.click();

    // 清理下载链接
    URL.revokeObjectURL(downloadLink.href);
  }else {
    message.error('数据导出失败')
  }
}

/***
 * 
 * plus minus times dividedBy
 * 
 */
export const calcFloat = (floats:Array<number>,type="plus") => {

  let result = floats.reduce((pre:any,nex:number)=>{
    return pre[type](new Decimal(nex)||0)
  },new Decimal(floats[0]))
  // console.log('/index.ts [49]--1',result.toString());

  return result.toString()
}
// 浮点数相乘
export function calcFloatTimes (a:number,b:number) {
  return ((new Decimal(a)).times(new Decimal(b))).toString()
  // return calcFloat([a,...rest],'times')
}
// 浮点数除法
export function calcFloatDividedBy (a:number,b:number) {
  // return calcFloat([a,...rest],'dividedBy')
  return ((new Decimal(a)).dividedBy(new Decimal(b))).toString()
}
// 千分位
export function formatNumberWithCommas(m:number|string) {
  return m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export const computedImageWH = (url:any) => {
    return new Promise((res)=>{
      // @ts-ignore
      const image:any = new Image()
      image.onload = ()=> {
        const {width,height} = image
        res({
          width,
          height
        })
      }
      image.src=url
      // image.src=img
    })
  
  }

